import { render } from "./InputList.vue?vue&type=template&id=53421cd1&scoped=true"
import script from "./InputList.vue?vue&type=script&lang=js"
export * from "./InputList.vue?vue&type=script&lang=js"

import "./InputList.vue?vue&type=style&index=0&id=53421cd1&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-53421cd1"

export default script